<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Daftar Produk</b-card-title>
      <b-card-title class="mb-0">
        <div class="text-right">
          <b-badge
            v-if="useGiftWrap"
            variant="danger"
            class="d-flex align-items-center"
          >
            <feather-icon
              icon="GiftIcon"
              class="mr-50"
            />
            Tambah Bungkus Kado
          </b-badge>
        </div>
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <div
      v-for="(item, index) in productList"
      :key="`item-data-${index}`"
      class="product-list"
    >
      <b-media vertical-align="start">
        <template #aside>
          <b-img
            rounded
            width="100"
            :src="linkStaging(item.product.images[0].image_url, 100, 100)"
            :alt="item.product.name"
            @error="(event) => {
              event.target.src = require('@/assets/images/icons/broken-image.svg')
            }"
          />
        </template>
        <div
          v-if="item.is_preorder"
          class="alert alert-danger d-flex align-items-center"
        >
          <feather-icon
            icon="BellIcon"
            class="mr-50"
          />
          Produk ini adalah produk pre-order
        </div>
        <span
          class="font-weight-bolder d-block"
          :class="item.attribute_concat ? '' : 'pb-1'"
        >
          {{ item.product.name }}
          <b-badge
            v-if="item.gift"
            variant="light-primary"
          >
            {{ item.gift.is_group ? 'Registry Patungan' : 'Registry Individu' }}
          </b-badge>
        </span>
        <div
          v-if="item.attribute_concat"
          class="font-weight-normal d-block pb-1"
        >
          {{ item.attribute_concat }}
        </div>
        <b-table-simple
          borderless
        >
          <b-tbody>
            <b-tr>
              <b-td class="p-0 w15">
                SKU
              </b-td>
              <b-td class="p-0">
                <span class="pr-1">:</span>
                {{ item.sku_name ? item.sku_name : '-' }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td class="p-0 w15">
                QTY
              </b-td>
              <b-td class="p-0">
                <span class="pr-1">:</span>
                {{ item.qty }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                class="p-0 pt-1"
                colspan="2"
              >
                <span class="font-weight-bolder">
                  {{ toCurrency(item.subtotal) }}
                  <b-badge
                    v-if="item.gift && item.gift.payment_completed && item.gift.is_group"
                    variant="light-success"
                  >
                    Lunas
                  </b-badge>
                  <b-badge
                    v-else-if="item.gift && !item.gift.payment_completed && item.gift.is_group"
                    variant="light-warning"
                  >
                    Belum Lunas
                  </b-badge>
                </span>
                <span
                  v-if="item.discount"
                  class="line-trough"
                >
                  {{ toCurrency(item.original_price) }}
                </span>
                <div v-if="item.gift && item.gift.is_group">
                  <small>
                    ~ {{ toCurrency(item.gift.payment_progress) }} / {{ toCurrency(item.gift.subtotal_price) }} ({{ getPriceGrupRegistry(item.gift) }})
                  </small>
                </div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                class="p-0 pt-1"
                colspan="2"
              >
                <span v-if="item.notes && item.gift && item.gift.description">
                  <b>Catatan: </b><br>{{ item.notes }}. {{ item.gift.description }}
                </span>
                <span v-else-if="item.notes">
                  <b>Catatan: </b><br>{{ item.notes }}
                </span>
                <span v-else-if="item.gift && item.gift.description">
                  <b>Catatan: </b><br>{{ item.gift.description }}
                </span>
                <i
                  v-else
                  class="text-muted"
                >
                  Tidak ada catatan Pembeli
                </i>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-media>
    </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMedia,
  BImg,
  BTableSimple,
  BTr,
  BTbody,
  BTd,
  BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMedia,
    BImg,
    BTableSimple,
    BTr,
    BTbody,
    BTd,
    BBadge,
  },
  props: {
    productList: {
      type: Array,
      default: () => ([]),
    },
    useGiftWrap: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    getPriceGrupRegistry(data) {
      const totalMustPay = data.subtotal_price
      const paymentProgress = data.payment_progress

      return `${Math.ceil((paymentProgress / totalMustPay) * 100)}%`
    },
  },
}
</script>

<style lang="scss" scoped>
dt {
    font-weight: bolder !important;
}

.w15 {
  width: 10%;
}

.product-list {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid#eee;

  &:last-child {
    border: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
}

.line-trough {
  text-decoration: line-through;
}
</style>
